import styles from './ServiceDetail.module.scss'

interface ServiceDetailItemProps {
  item: {
    title: string
    linkText?: string
    linkUrl?: string
    subTitle1: string
    text1: string
    subTitle2: string
    text2: string
    subTitle3: string
    text3: string
  }
  index: number
}

const ServiceDetailItem: React.FC<ServiceDetailItemProps> = ({ item, index }) => {
  return (
    <article className={`${styles.service__item} Service_item0${index + 1}`}>
      <div className={styles.service__item__left}>
        <h3 className={styles.service__item__left__title}>{item.title}</h3>
        {item.linkText && item.linkUrl && (
          <p className={styles.service__item__left__link}>
            <a href={item.linkUrl}>{item.linkText}</a>
          </p>
        )}
      </div>
      <div className={styles.service__item__cts}>
        <h4 className={styles.service__item__cts__sub}>{item.subTitle1}</h4>
        <p className={styles.service__item__cts__text}>{item.text1}</p>
        {item.subTitle2 && item.text2 && (
          <>
            <h4 className={styles.service__item__cts__sub}>{item.subTitle2}</h4>
            <p className={styles.service__item__cts__text}>{item.text2}</p>
          </>
        )}
        {item.subTitle3 && item.text3 && (
          <>
            <h4 className={styles.service__item__cts__sub}>{item.subTitle3}</h4>
            <p className={styles.service__item__cts__text}>{item.text3}</p>
          </>
        )}
      </div>
    </article>
  )
}

export default ServiceDetailItem
